const clubMembershipId = 'ClubMembership'

export default clubMembershipId
